const CHOTTULINK_API_URL = 'https://api2.chottulink.com/chotuCore/pa/v1/create-link'
const API_KEY = process.env.VUE_APP_CHOTTULINK_API_KEY
const DOMAIN = 'feeds.chottu.link'

export async function createShareLink({ selectedPath, destinationUrl, linkName }) {
  try {
    const response = await fetch(CHOTTULINK_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'API-KEY': API_KEY,
      },
      body: JSON.stringify({
        domain: DOMAIN,
        selected_path: selectedPath,
        destination_url: destinationUrl,
        link_name: linkName,
        ios_behavior: 2,
        android_behavior: 2,
      }),
    })

    const data = await response.json()

    if (response.ok && data.status === 'success') {
      return data.short_url
    }

    // Only fall back for conflict (link already exists), throw on everything else
    if (response.status === 409) {
      console.warn('ChottuLink link already exists, using constructed URL')
      return `https://${DOMAIN}/${selectedPath}`
    }

    throw new Error(data.errorMessage || data.message || `API error ${response.status}`)
  } catch (error) {
    // Re-throw application errors, only fall back for network failures
    if (error.message) throw error
    throw new Error('Network error creating share link')
  }
}
